var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"body-1 gray-text text-center",class:_vm.data.staticClass},[_vm._v(" Capital Nexus Investment Ltd."),_c('br'),_vm._v(" Company No: 15603311"),_c('br'),_vm._v(" Registered office: 11 Pheasant Walk, High Legh, Knutsford, Cheshire, England, WA16 6LU ")])}
var staticRenderFns = []

export { render, staticRenderFns }